import { node } from 'prop-types';
import React, { createContext, startTransition, useMemo, useState } from 'react';

export const BreadcrumbContext = createContext([]);

// The app context provider component
const BreadcrumbContextProvider = ({ children }) => {
    const [breadcrumbList, setBreadcrumbList] = useState([]);
    const updateBreadcrumbs = (newValue = []) =>
        startTransition(() =>
            setBreadcrumbList([['Home', '/'], ...(newValue ?? [])]));
    const contextValue = useMemo(() => ({
        breadcrumbList,
        updateBreadcrumbs,
    }), [breadcrumbList, updateBreadcrumbs]);
    return (<BreadcrumbContext.Provider
        value={contextValue}>
        {children}
    </BreadcrumbContext.Provider>);
};

BreadcrumbContextProvider.propTypes = {
    children: node,
};

export default BreadcrumbContextProvider;